export default "__VITE_ASSET__D3Y4yMc$__"